const convert_from_input = (date) => {
	var newDate = date.split('-')
	console.log("1,2,0", newDate[1],newDate[2],newDate[0])
	return `${newDate[1]}/${newDate[2]}/${newDate[0]}`
}

export default convert_from_input